import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "selectAll", "actions", "count", "total"]
  static values = { pricePerItem: Number }

  connect() {
    this.updateUI()
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = checked
    })
    this.updateUI()
  }

  toggle() {
    this.updateUI()
  }

  updateCount() {
    this.updateUI()
  }

  updateUI() {
    const checkedCount = this.checkboxTargets.filter(cb => cb.checked).length
    const totalCount = this.checkboxTargets.length

    // Update select all checkbox state
    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = checkedCount === totalCount && totalCount > 0
      this.selectAllTarget.indeterminate = checkedCount > 0 && checkedCount < totalCount
    }

    // Show/hide bulk actions
    if (this.hasActionsTarget) {
      if (checkedCount > 0) {
        this.actionsTarget.classList.remove("hidden")
      } else {
        this.actionsTarget.classList.add("hidden")
      }
    }

    // Update all count displays (use countTargets plural to get all)
    this.countTargets.forEach(el => {
      el.textContent = checkedCount
    })

    // Update total price if we have a price and total target
    if (this.hasTotalTarget && this.hasPricePerItemValue) {
      const totalPrice = (checkedCount * this.pricePerItemValue).toFixed(2)
      this.totalTargets.forEach(el => {
        el.textContent = totalPrice
      })
    }
  }

  getSelectedIds() {
    return this.checkboxTargets
      .filter(cb => cb.checked)
      .map(cb => cb.value)
  }
}
